import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { SelectStoreTypeStepOptions } from './components/SelectStoreTypeStepOptions';
import { useAppStore } from 'stores/state';
import { biEvents } from 'api/bi-events';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi-events';
import { StepId } from 'config/flow';

export const SelectStoreTypeStep: FC = () => {
  const { t } = useTranslation();

  const storeType = useAppStore((state) => state.storeType);

  return (
    <StepLayout
      nextButtonProps={{ label: t('select-store-type-step.actions.next-button'), disabled: !storeType }}
      description={t('select-store-type-step.description')}
      title={t('select-store-type-step.title')}
      onNext={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectStoreType],
          action: BI_ACTION_NAME.NEXT,
          value: storeType,
        });
      }}
    >
      <SelectStoreTypeStepOptions />
    </StepLayout>
  );
};
